import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBanquet } from "../../../Redux/App/action";
import {
  Flex,
  Box,
  Image,
  useColorModeValue,
  Spinner,
  Text,
  Select,
  Input,
  InputGroup,
  InputLeftElement,
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  CheckboxGroup,
  Checkbox,
  Tag,
} from "@chakra-ui/react";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { Link } from "react-router-dom";

const Banquet = () => {
  const dispatch = useDispatch();
  const { banquetHall, isLoading } = useSelector((store) => store.appReducer);
  useEffect(() => {
    dispatch(getBanquet);
  }, [dispatch]);

  const bgcolor = useColorModeValue("white", "gray.800");
  const coll = useColorModeValue("gray.800", "white");
  const options = [
    "Less than 100",
    "100 - 250",
    "250 - 500",
    "500 - 1000",
    "1000 & above",
  ];
  console.log(options);
  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Box>
    );
  };
  if (isLoading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }
  return (
    <Flex p={1} gap={5} mt={2}>
      <Box
        w={"25%"}
        px={2}
        textAlign={"left"}
        display={{ md: "block", base: "none" }}
      >
        <Flex alignItems={"center"} justifyContent={"space-between"}>
          <Text
            color={"#AFAFAF"}
            fontWeight={"bold"}
            className="oswald-font"
            fontSize={20}
          >
            FILTER BY
          </Text>
          <Text color={"#6FADDC"} fontSize={14} _hover={{ cursor: "pointer" }}>
            Clear all
          </Text>
        </Flex>
        <Text
          color={"#372449"}
          fontSize={16}
          className="lato-font"
          fontWeight={"bold"}
          mt={4}
        >
          Select Locality
        </Text>
        <InputGroup mt={2} w={"98%"}>
          <InputLeftElement pointerEvents="none">
            <HiOutlineLocationMarker color="gray.300" />
          </InputLeftElement>
          <Input type="text" placeholder="Location" border={"1px solid gray"} />
        </InputGroup>
        {/* budget */}
        <Flex alignItems={"center"} justifyContent={"space-between"} mt={8}>
          <Text
            color={"#372449"}
            className="lato-font"
            fontWeight={"bold"}
            fontSize={16}
          >
            Budget
          </Text>
          <Text color={"#6FADDC"} fontSize={14} _hover={{ cursor: "pointer" }}>
            Clear
          </Text>
        </Flex>
        <Flex justifyContent={"space-between"} mt={1}>
          <Text
            color={"#372449"}
            fontSize={"14"}
            className="lato-font"
            fontWeight={"bold"}
          >
            Pricing method:
          </Text>
          <Text color={"#AFAFAF"} fontSize={"14"}>
            Per plate
          </Text>
          <Text color={"#AFAFAF"} fontSize={"14"}>
            Per day
          </Text>
        </Flex>
        <RangeSlider
          defaultValue={[120, 240]}
          min={0}
          max={300}
          step={30}
          mt={4}
        >
          <RangeSliderTrack bg="red.100">
            <RangeSliderFilledTrack bg="tomato" />
          </RangeSliderTrack>
          <RangeSliderThumb boxSize={6} index={0} />
          <RangeSliderThumb boxSize={6} index={1} />
        </RangeSlider>
        {/* number of guests */}
        <Flex alignItems={"center"} justifyContent={"space-between"} mt={5}>
          <Text
            color={"#372449"}
            className="lato-font"
            fontWeight={"bold"}
            fontSize={16}
          >
            Number of Guest
          </Text>
          <Text color={"#6FADDC"} fontSize={14} _hover={{ cursor: "pointer" }}>
            Clear
          </Text>
        </Flex>
        <CheckboxGroup variantColor="blue">
          <Flex flexDirection={"column"} mt={4} color={"#AFAFAF"} px={2}>
            {options &&
              options.map((el, i) => (
                <Checkbox value={el} mb={2} borderColor={"#3182CE"} key={i}>
                  {el}
                </Checkbox>
              ))}
          </Flex>
        </CheckboxGroup>
      </Box>
      <Box w={{ md: "75%", base: "90%" }} textAlign={"left"}>
        <Flex justifyContent={"space-between"} alignItems={"center"}>
          <Box>
            <Flex
              alignItems={"baseline"}
              gap={1}
              flexDirection={{ md: "row", base: "column" }}
            >
              <Text
                color={"#3C375F"}
                fontSize={{ md: 20, base: 14 }}
                fontWeight={"bold"}
                className="oswald-font"
              >
                BEST WEDDING VENUES IN DELHI NCR
              </Text>
              <Text color={"#6FADDC"} fontSize={{ md: 14, base: 10 }}>
                (3403 found)
              </Text>
            </Flex>
            <Text
              color="#3E3E3E"
              fontSize={{ md: 14, base: 10 }}
              className="lato-font"
              mt={"-0.8%"}
            >
              Wishfy is there to help you out with a list of Best Wedding Venues
            </Text>
          </Box>
          <Flex
            alignItems={"center"}
            display={{ md: "flex", base: "none" }}
            w={"30%"}
          >
            <Text fontWeight={"bold"} className="lato-font">
              Sort By:
            </Text>
            <Select
              h={8}
              w={"45%"}
              border={0}
              className="lato-font"
              _focusVisible={false}
            >
              <option>Popularity</option>
            </Select>
          </Flex>
        </Flex>
        <Box
          m={"auto"}
          mt={4}
          display={"grid"}
          gridTemplateColumns={{
            md: "repeat(3,300px)",
            base: "repeat(1,290px)",
          }}
          gap={5}
          p={2}
        >
          {banquetHall &&
            banquetHall.map((el, i) => (
              <Box bg="white" maxW="sm" key={i} cursor={"pointer"}>
                <Link key={i} to={`/ComingSoon`}>
                  <Image
                    src={el.img}
                    alt={`error in ${i}`}
                    rounded="lg"
                    w={"100%"}
                  />
                  <Box>
                    <Text
                      fontWeight="bold"
                      as="h2"
                      className="oswald-font"
                      lineHeight="tight"
                      noOfLines={1}
                      color={"#06211A"}
                    >
                      {el.serviceName}
                    </Text>
                    <Text
                      display="flex"
                      className="lato-font"
                      alignItems="baseline"
                      fontWeight={"normal"}
                      fontSize={14}
                      color={"#787A79"}
                    >
                      {el.areaOfService}, {el.city}
                    </Text>
                    <Text
                      className="lato-font"
                      alignItems="baseline"
                      fontWeight={"normal"}
                      fontSize={14}
                      color={"#395D00"}
                    >
                      <span style={{ color: "#3C375F" }}>
                        Price Started From...
                      </span>
                      ₹{el.priceStartRange}
                    </Text>
                    <Text
                      className="lato-font"
                      alignItems="baseline"
                      fontWeight={"normal"}
                      fontSize={14}
                      color={"#3C375F"}
                    >
                      Indoor/ Outdoor • {el.minCapacity}-{el.maxCapacity} people
                    </Text>
                  </Box>
                </Link>
              </Box>
            ))}
        </Box>
      </Box>
    </Flex>
  );
};

export default Banquet;
